import React, { useState } from "react";
import CreateContrcatStep1 from "./Create-contract";
import Leftbar from "../../components/Leftsidebar";
import Topbar from "../../components/Topbar";
import { Link } from "react-router-dom";
import Contractdetails from "./Contract-details";
import ProjectnameContrcat from "./Projectname-contract";
import EditContract from "./Projectname-contract/EditContract";
import Success from "./Success";

const CreateContract = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [step, setStep] = useState(1);

  const handleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const handleSidebarClose = () => {
    setShowSidebar(false);
  };

  const handleStep = (e) => {
    e.preventDefault();
    setStep(step + 1)
  }

  return (
    <>
      <div className="g-sidenav-show bg-gray-100 min-vh-100">
        <div id="wrapper">
          <Leftbar showSidebar={showSidebar} handleSidebarClose={handleSidebarClose} />
          <main className="main-content border-radius-lg">
            <Topbar handleSidebar={handleSidebar} />
            <div className="header header-bg-lender">
              <div className={step === 5 ? "" : "Contrcat-conatiner"}>
                {step === 1 && <CreateContrcatStep1 handleStep={handleStep} />}
                {step === 2 && <Contractdetails handleStep={handleStep} />}
                {step === 3 && <ProjectnameContrcat handleStep={handleStep} />}
                {step === 4 && <EditContract handleStep={handleStep} />}
                {step === 5 && <Success handleStep={handleStep} />}
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  )
}
export default CreateContract; 